/**
 * Reusable step builder helpers.
 * Each returns a partial Shepherd step config.
 */

function progressHtml(current, total) {
  const pct = Math.round((current / total) * 100);
  return `<div class="lawis-tour-progress"><div class="lawis-tour-progress-bar" style="width:${pct}%"></div></div>`;
}

function counterHtml(current, total, t) {
  const label = t
    ? t('onboarding_tour.step_counter', { current, total })
    : `Step ${current} of ${total}`;
  return `<div class="lawis-step-counter">${label}</div>`;
}

/**
 * First step — no Back button, has Skip + Let's go.
 */
export function createWelcomeStep({ id, title, text, attachTo, t, totalSteps }) {
  return {
    id,
    title,
    text: progressHtml(1, totalSteps) + counterHtml(1, totalSteps, t) + `<p>${text}</p>`,
    ...(attachTo ? { attachTo } : {}),
    buttons: [
      { text: t?.('onboarding_tour.skip') || 'Skip tour', action: 'cancel', classes: 'shepherd-button-secondary' },
      { text: t?.('onboarding_tour.lets_go') || "Let's go", action: 'next', classes: 'shepherd-button-primary' },
    ],
  };
}

/**
 * Middle step — has Back + Next.
 */
export function createMiddleStep({ id, title, text, attachTo, t, stepIndex, totalSteps }) {
  return {
    id,
    title,
    text: progressHtml(stepIndex, totalSteps) + counterHtml(stepIndex, totalSteps, t) + `<p>${text}</p>`,
    ...(attachTo ? { attachTo } : {}),
    buttons: [
      { text: t?.('onboarding_tour.back') || 'Back', action: 'back', classes: 'shepherd-button-secondary' },
      { text: t?.('onboarding_tour.next') || 'Next', action: 'next', classes: 'shepherd-button-primary' },
    ],
  };
}

/**
 * Final step — has Back + Done.
 */
export function createFinalStep({ id, title, text, attachTo, t, totalSteps }) {
  return {
    id,
    title,
    text: progressHtml(totalSteps, totalSteps) + counterHtml(totalSteps, totalSteps, t) + `<p>${text}</p>`,
    ...(attachTo ? { attachTo } : {}),
    buttons: [
      { text: t?.('onboarding_tour.back') || 'Back', action: 'back', classes: 'shepherd-button-secondary' },
      { text: t?.('onboarding_tour.done') || 'Done', action: 'complete', classes: 'shepherd-button-primary' },
    ],
  };
}
